<div class="users-container" data-name="User-list" data-node-id="3149-4610">
  <div class="users-list">
    <!-- Static 15 rows that get populated with data -->
    <div class="user-item" 
         *ngFor="let user of getDisplayUsers(); trackBy: trackByUsername; let i = index"
         [class.highlighted]="i === 0">
      <div class="user-info">
        <div class="platform-icons">
          <div class="platform-icon youtube" *ngIf="user?.is_youtube">
            <svg viewBox="0 0 15 11" class="icon">
              <path d="M14.9982 5.33489C14.9924 4.21074 14.9912 3.02674 14.6933 1.9351C14.4813 1.15872 13.8529 0.431015 13.0558 0.309588C11.2196 0.0273469 9.36634 0 7.51062 0C5.64841 0 3.7872 0.024595 1.94447 0.306492C1.14567 0.428779 0.513282 1.15975 0.304595 1.9363C0.00154924 3.06148 0.00254771 4.28504 0.00038429 5.44582C-0.0014463 6.63705 -0.00860224 7.90085 0.307923 9.05768C0.519938 9.83165 1.14733 10.554 1.94097 10.6796C3.61862 10.9443 5.30526 10.9868 7.00188 10.9971C9.02618 11.0095 11.0571 10.9938 13.0595 10.6772C13.8524 10.5518 14.479 9.82941 14.6903 9.05596C15.0157 7.86491 15.0047 6.56206 14.9982 5.33471M7.96011 6.68383L5.98274 7.8637V3.14438L7.96011 4.32425L9.93731 5.50378L7.96011 6.68383Z" fill="white"/>
            </svg>
          </div>
          <div class="platform-icon twitch" *ngIf="user?.is_twitch">
            <svg viewBox="0 0 14 14" class="icon">
              <path d="M3.06687 1.21794H12.8215V7.91452L10.7501 10.0426H7.50065L5.72775 11.8672V10.0426H3.06687V1.21794ZM1.88385 0L1 2.43589V12.1705H4.24946V13.9993H6.02171L7.79397 12.1705H10.4555L14 8.52137V0H1.88385Z" fill="white"/>
              <path d="M9.25011 6.65406H10.4331V3H9.25011V6.65406ZM6.00065 6.64937H7.18367V3H6L6.00065 6.64937Z" fill="white"/>
            </svg>
          </div>
          <!-- Placeholder for consistent spacing when no icons -->
          <div class="platform-icon placeholder" *ngIf="!user?.is_youtube && !user?.is_twitch">
            <div class="placeholder-icon"></div>
          </div>
        </div>
        <div class="username">{{ user?.username || '&nbsp;' }}</div>
      </div>
      <div class="user-time">{{ user?.time ? '+' + (user.time | minutesToHm) : '&nbsp;' }}</div>
    </div>
  </div>
</div>
